import React from "react";
import { Col, Row, Container } from "reactstrap";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import "../../../Assets/Scss/Home3newlyaddedstore.scss";
import { BASE_URL } from "../../../Config/axiosInstance";

const NewlyAddedstore = () => {
  const { newlyAddedStores } = useSelector((state) => state.Stores);
  return (

    <div className="carousel pt-1 pb-0">
      <Container>
        {" "}
        <h5 className="Recommended" style={{color:"#2b3cbb", fontSize:"1.7rem", marginLeft:"5px"}}> Newly Added Stores</h5>{" "}
      </Container>

      <div style={{ background: "#f0f0f0" }}>
        <Container >
          <Row id="most-t-row-h3">
            {newlyAddedStores.slice(0, 12).map((store, index) => (
              
              <Col lg="2" key={index}>
                <Link to={`/store/${store?.slug}`}>
                  <div
                    className="imgdiv"
                    style={{ borderColor: "white" }}
                  >
                    <img className="imgDesign"
                      src={`${BASE_URL}/${store?.image}`}
                      alt="store"
                      width="100%"
                      height="150px"
                      style={{ objectFit: "contain" , borderColor: "#2b3cbb"}}
                    />
                  </div>
                </Link>
              </Col>
            ))}
          </Row>
        </Container>
      </div>
    </div>
  );
};

export default NewlyAddedstore;
